import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {Modal, ModalProps} from '../modal/modal';
import {Stack, Typography} from '@mui/material';
import './careplan-modal.scss';
import {getActivityNameByActivitySectorId} from '../../utils/functions/get-activity-name-by-section';
import {CarePlan} from '../../backend/interfaces/care-plan';
import {useSeniorSidebar} from '../../contexts/seniors-sidebar/context';
import {useMemo} from 'react';

interface DeleteCarePlanModalProps extends Omit<ModalProps, 'actions'> {
  open: boolean;
  entry?: CarePlan | null;
  submitting?: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteCarePlanModal = ({
  open,
  entry,
  submitting = false,
  onClose,
  onDelete,
}: DeleteCarePlanModalProps) => {
  const {t} = useTranslation();
  const sidebarContext = useSeniorSidebar();

  const seniorName = useMemo(() => {
    if (!entry?.userId) return;

    const senior = sidebarContext.state.list?.get(entry.userId);
    return senior ? senior.originalData.displayName || senior.originalData?.name : '';
  }, [entry?.userId, sidebarContext.state.list]);

  const activityName = getActivityNameByActivitySectorId(entry?.activitiesSectorId);

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="delete-modal"
      preventCloseClick
      title={`${t(translations.generic_header.actions.delete)}: ${activityName && t(translations.role_permissions[activityName])}`}
      actions={[
        {
          label: t(translations.modal.cancel),
          type: 'destructive',
          onClick: onClose,
        },
        {
          label: t(translations.modal.delete),
          type: 'nondestructive',
          onClick: onDelete,
          loading: submitting,
        },
      ]}
    >
      <Stack className="container">
        <Typography className="title">
          {t(translations.seniors.edit.senior_dcm.careplan.on_delete.title, {name: seniorName})}
        </Typography>
        <Typography className="subtitle">
          {t(translations.seniors.edit.senior_dcm.careplan.on_delete.description)}
        </Typography>
      </Stack>
    </Modal>
  );
};
